import React from 'react';

const AppHousehold = ({ err, values, handleChange, prevStep, nextStep, focusedTitleRef }) => {
    const { motivation, numberAdults, children, numberChildren, birthyearsChildren, pets, petsType } = values;
    const e = err || {};

    return (
        <div>
            <h2 ref={focusedTitleRef} tabIndex={-1}>Haushalt</h2>

            <div className="mb-4">
                <label className="form-label" htmlFor="motivation">Grund des Wohnungswechsels <span className="required-marker">*</span></label>
                <textarea
                    id="motivation"
                    className={`form-control${e.motivation ? ' is-invalid' : ''}`}
                    rows={5}
                    value={motivation}
                    onChange={handleChange('motivation')}
                    maxLength={1000}
                />
                {e.motivation && <div className="invalid-feedback">{e.motivation}</div>}
            </div>

            <div className="row mb-4">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="numberAdults">Anzahl erwachsener Personen <span className="required-marker">*</span></label>
                    <select id="numberAdults" className="form-select" value={numberAdults} onChange={handleChange('numberAdults')}>
                        {[1, 2, 3, 4, 5, 6].map(n => (
                            <option key={n} value={n}>{n} {n === 1 ? 'Person' : 'Personen'}</option>
                        ))}
                    </select>
                </div>
            </div>

            <fieldset className="mb-4">
                <legend className="form-label">Ziehen Kinder mit Ihnen ein? <span className="required-marker">*</span></legend>
                <div className="form-check">
                    <input className={`form-check-input${e.children ? ' is-invalid' : ''}`} type="radio" id="childrenYes" name="children" value="yes" checked={children === 'yes'} onChange={handleChange('children')} />
                    <label className="form-check-label" htmlFor="childrenYes">Ja</label>
                </div>
                <div className="form-check">
                    <input className={`form-check-input${e.children ? ' is-invalid' : ''}`} type="radio" id="childrenNo" name="children" value="no" checked={children === 'no'} onChange={handleChange('children')} />
                    <label className="form-check-label" htmlFor="childrenNo">Nein</label>
                </div>
                {e.children && <div className="invalid-feedback d-block">{e.children}</div>}
            </fieldset>

            {children === 'yes' && (
                <div className="row mb-4">
                    <div className="col-12 col-md-4">
                        <label className="form-label" htmlFor="numberChildren">Anzahl Kinder <span className="required-marker">*</span></label>
                        <input
                            id="numberChildren"
                            type="number"
                            className={`form-control${e.numberChildren ? ' is-invalid' : ''}`}
                            min={1}
                            max={6}
                            value={numberChildren}
                            onChange={handleChange('numberChildren')}
                        />
                        {e.numberChildren && <div className="invalid-feedback">{e.numberChildren}</div>}
                    </div>
                    <div className="col-12 col-md-8">
                        <label className="form-label" htmlFor="birthyearsChildren">Jahrgänge der Kinder</label>
                        <input id="birthyearsChildren" type="text" className="form-control" value={birthyearsChildren} onChange={handleChange('birthyearsChildren')} placeholder="z.B. 2015, 2018" />
                    </div>
                </div>
            )}

            <fieldset className="mb-4">
                <legend className="form-label">Besitzen Sie Haustiere? <span className="required-marker">*</span></legend>
                <div className="form-check">
                    <input className={`form-check-input${e.pets ? ' is-invalid' : ''}`} type="radio" id="petsYes" name="pets" value="yes" checked={pets === 'yes'} onChange={handleChange('pets')} />
                    <label className="form-check-label" htmlFor="petsYes">Ja</label>
                </div>
                <div className="form-check">
                    <input className={`form-check-input${e.pets ? ' is-invalid' : ''}`} type="radio" id="petsNo" name="pets" value="no" checked={pets === 'no'} onChange={handleChange('pets')} />
                    <label className="form-check-label" htmlFor="petsNo">Nein</label>
                </div>
                {e.pets && <div className="invalid-feedback d-block">{e.pets}</div>}
            </fieldset>

            {pets === 'yes' && (
                <div className="mb-4">
                    <label className="form-label" htmlFor="petsType">Art/Rasse <span className="required-marker">*</span></label>
                    <input
                        id="petsType"
                        type="text"
                        className={`form-control${e.petsType ? ' is-invalid' : ''}`}
                        value={petsType}
                        onChange={handleChange('petsType')}
                    />
                    {e.petsType && <div className="invalid-feedback">{e.petsType}</div>}
                </div>
            )}

            <div className="d-flex justify-content-between flex-row-reverse mt-5">
                <button className="btn btn-secondary" onClick={nextStep}>Weiter</button>
                <button className="btn btn-secondary btn-back" onClick={prevStep}>Zurück</button>
            </div>
        </div>
    );
};

export default AppHousehold;
